// read from .env

const apiBaseUrl =
    process.env.REACT_APP_ADMIN_BACKEND_API_URL ||
    process.env.ADMIN_BACKEND_API_URL ||
    'http://localhost/api/v1';
const distributeUrl = 'http://localhost:3006/api/v1';
const wsApiBaseUrl = 'http://localhost:3007/api/v1';
const captchaSiteKey = '6LcM97YZAAAAAEtCTI9Nafrz5n-69C95fNv3vpPA';
const admin_mode = "localhost"
const ENDYSTATUS = false

const refreshWinningByMatchCron = process.env.REACT_APP_ADMIN_REFRESH_WINNING_BY_MATCH_CRON || 'https://allcronpython.web11.world/api/v1.0/set_winning';
const leaderboardURL = process.env.REACT_APP_ADMIN_LEADERBOARD_URL || 'http://13.232.51.228:6001';
const cronBaseURL = process.env.REACT_APP_ADMIN_CRON_BASE_URL || 'https://nodecronall.web11.world';
const updateMatchListCron = process.env.REACT_APP_ADMIN_UPDATE_MATCH_LIST_CRON || 'https://nodecronall.web11.world/get-matches';
const updateFootballMatchListCron = process.env.REACT_APP_ADMIN_UPDATE_FOOTBALL_MATCH_LIST_CRON || 'https://nodecronall.web11.world/get-football-matches';
const updateKabaddiMatchListCron = process.env.REACT_APP_ADMIN_UPDATE_KABADDI_MATCH_LIST_CRON || 'https://nodecronall.web11.world/get-kabaddi-matches';
const publicPlayerImagePath = 'https://web11-images.s3.ap-south-1.amazonaws.com/';
const publicTeamImagePath = 'https://web11-images.s3.ap-south-1.amazonaws.com/';
const publicSliderImagePath = 'https://web11-images.s3.ap-south-1.amazonaws.com/';
const allCronPythonURL = process.env.REACT_APP_ADMIN_ALL_CRON_PYTHON_URL || 'https://allcronpython.web11.world/api/v1.0';
const publicSliderImagePathCloudflare = 'https://web11-images-bucket.sgp1.cdn.digitaloceanspaces.com/'; // +digital ocean spaces

const fantasyGullyBaseUrl = 'https://beta-fg-admin.sportz.io/api/ClientApi/AddClientContest';
const fantasyPlatformGuid = "7f1ca399-32da-456c-a036-65573b8aaeb7";
const tinyKey = '1c7lrgvmqiq3lzj10teywyqrr71hgc58gg67fw6th534beri';

// contest categories
const contestCategory = {
    mega: 'mega',
    hot: 'hot',
    prime: 'prime',
    headToHead: 'headToHead',
    fiftyFifty: 'fiftyFifty'
};
// tiny editor account

const dateTimeFormat = 'MMMM Do, YYYY';

const defaultCurrency = 'INR';
const currency = { inr: 'INR', doller: '$' };

const majorContestCategories = ['mega', 'hot', 'headtohead', 'prime', 'fiftyfifty'];

const profitPercent = 20;

const scheduleType = { live: 'running', upcoming: 'upcoming', completed: 'completed', cancelled: 'cancelled', delayed: "delayed" };

const maxFileSizeUpload = 2097152; // in bytes
const maxFileNameLengthUpload = 50;

const adminRoles = ['admin', 'subadmin'];

const accessModules = [

    { value: 'dashboard', label: 'Dashboard' },
    { value: 'users', label: 'Users' },
    { value: 'contestCategories', label: 'Contest Categories' },
    { value: 'contests', label: 'Contests' },
    { value: 'contestsSchedule', label: 'Contests Schedule' },
    { value: 'walletManager', label: 'Wallet Manager' },
    { value: 'withdrawRequests', label: 'Withdraw Requests' },
    { value: 'slider', label: 'Banner' },
    { value: 'playerManager', label: 'Player Manager' },
    { value: 'pointsSystem', label: 'Points System' },
    { value: 'paymentOffers', label: 'Payment Offers' },
    { value: 'notification', label: 'Notification' },
    { value: 'emailTemplates', label: 'Email Templates' },
    { value: 'transaction', label: 'Transaction' },
    { value: 'referralBonus', label: 'Referral Bonus' },
    { value: 'teamManager', label: 'Team Manager' },
    { value: 'seriesManager', label: 'Series' },
    { value: 'seriesMatchesManager', label: 'Series Matches' },
    { value: 'gst', label: 'Gst' },
    { value: 'tds', label: 'Tds' },
    { value: 'DepositWithdraw', label: 'Deposit withdraw report' },
    { value: 'excel', label: 'Send Excel' },
    { value: 'contents', label: 'Content Manager' },
    { value: 'blogs', label: 'Blog Manager' },
    { value: 'pullApi', label: 'Pull API Manager' },
    { value: 'matchBannerManager', label: 'Match Banner Manager' },
    { value: 'offers', label: 'Offer Manager' },
    { value: 'pressRelease', label: 'Press Release Manager' },
    { value: 'revenue', label: 'Revenue Commission Manager' },
    { value: 'careerManager', label: 'Career Manager' },
    { value: 'feedback', label: 'User Feedback' },
    { value: 'otherGame', label: 'Other Game Match List' },
    { value: 'otherGameTransactionList', label: 'Other Game Transaction List' },
    { value: 'otherGameRevenueComm', label: 'Other Game Revenue Comm.' },
    { value: 'otherGameGst', label: 'Other Game GST Manager' },
    { value: 'deposit', label: 'Add Cash Banner' },
    { value: 'playstore', label: 'Playstore Banner' },
    { value: 'PredictionTrasactionTable', label: 'Prediction Transaction' },
    {value: 'otherGamesContests', label: 'Other Games Contests'},
    {value : 'diposite', label: 'Diposite'},
];

const defaultAccessModules = [
    { value: 'dashboard', label: 'Dashboard' },
    { value: 'users', label: 'Users' },
    { value: 'contestCategories', label: 'Contest Categories' },
    { value: 'contests', label: 'Contests' },
    { value: 'contestsSchedule', label: 'Contests Schedule' },
    { value: 'walletManager', label: 'Wallet Manager' },
    { value: 'withdrawRequests', label: 'Withdraw Requests' },
    { value: 'slider', label: 'Slider' },
    { value: 'playerManager', label: 'Player Manager' },
    { value: 'settingManager', label: 'Setting Manager' },
    { value: 'pointsSystem', label: 'Points System' },
    { value: 'paymentOffers', label: 'Payment Offers' },
    { value: 'levelOffers', label: 'Level Offers' },
    { value: 'notification', label: 'Notification' },
    {value: 'otherGamesContests', label: 'Other Games Contests'},
    {value: 'diposite', label: 'Diposite'},

]

const MultiExchangeValues = {
    multi_exchange_runs: 1,
    multi_exchange_wickets: 2,
    multi_exchange_sixes: 3,
    multi_exchange_fours: 4,
    multi_exchange_fantasy_points: 5
};

const TransactionTypes = {
    CASH_DEPOSIT: 1,
    MOBILE_VERIFY: 2,
    JOIN_CONTEST: 3,
    WON_CONTEST: 4,
    FRIEND_JOIN_CONTEST: 5,
    REFUND: 6,
    LEVEL_UP: 7,
    COUPON_BONUS: 8,
    WITHDRAWAL: 9,
    FRIEND_USED_INVITE: 10,
    TRANSACTION_PENDING: 11,
    TRANSACTION_REJECT: 12,
    TRANSACTION_CONFIRM: 13,
    ADMIN_ADDED: 14,
    ADMIN_DEDUCTED: 15,
    LEAGUE_REFER_BONUS: 16,
    MATCH_REFUND: 17,
    TDS: 18,
    EXTRA_BONUS: 19,
    BONUS_WIN: 20,
    EXTRA_DEPOSITE: 21,
    FIRST_DEPOSITE_BONUS: 22,
    COUPON_PURCHASE_TXN: 23,
    WEEKLY_LEADERBOARD_WIN: 24,
    FRIEND_FIRST_DEPOSIT_REWARD: 25,
    SIGNUP_BONOUS_REWARD:26,
    SIGNUP_XTRA_CASH_REWARD:27,
    AFFIL_AMOUNT_AT_DEPOST:28,
    AFFIL_AMOUNT_WITHDRAWAL_FOR_DEPOST:29,
    WON_CONTEST_FREEGIVEAWAY:30,
    SERIES_LEADERBOARD_WIN:31,
    FRIEND_PAN_VERIFY_XCASH_REWARD:32,
    FRIEND_BANK_VERIFY_XCASH_REWARD:33,
    FIRST_DEPOSITE_XCASH_REWARD:34,
    USER_BANK_VERIFY_XCASH_REWARD: 35,
    REAL_CODE_SIGNUP_XCASH_REWARD: 36,
    JOIN_CONTEST_REWARD: 37,
    INSTANT_BANK_VERIFIED: 38,
    FRIEND_JOIN_CONTEST_DEPOSIT: 39,
    AFFILIATE_REWARD: 40,
    AFFILIATE_REWARD_PREDICTION: 41,
    AFFILIATE_REWARD_TRADE: 42
};
const TransactionTypesByValues =  {
    CASH_DEPOSIT : 'Deposited Cash',
    MOBILE_VERIFY : 'Mobile Verified',
    JOIN_CONTEST : 'Joined A Contest',
    WON_CONTEST : 'Won A contest',
    FRIEND_JOIN_CONTEST : 'Friend Joined Contests Reward In Xtra',
    REFUND : 'Contest Cancelled',
    MATCH_REFUND : 'Match Cancelled',
    LEVEL_UP : 'Level Up Cash Credited',
    COUPON_BONUS : 'Coupon Bonus',
    // WITHDRAWAL			:	'Withdrawal',
    FRIEND_USED_INVITE : 'Friend Used Invite Code',
    TRANSACTION_PENDING : 'Withdraw Pending',
    TRANSACTION_REJECT : 'Withdraw Rejected',
    TRANSACTION_CONFIRM : 'Withdraw Confirmed',
    ADMIN_ADDED : 'Admin Added',
    ADMIN_DEDUCTED : 'Admin Deducted',
    LEAGUE_REFER_BONUS : 'Join League Referral Bonus',
    TDS : 'Tax Deducted at Source',
    EXTRA_BONUS : 'Extra Amount',
    BONUS_WIN : 'Team Clash Bonus',
    EXTRA_DEPOSITE : "Extra Deposite",
    FIRST_DEPOSITE_BONUS : "First Deposite Bonus",
    COUPON_PURCHASE_TXN : "Coupon Purchase",
    WEEKLY_LEADERBOARD_WIN : "Weekly Leaderboard Reward",
    FRIEND_FIRST_DEPOSIT_REWARD: "Friend First Time Deposit Reward",
    SIGNUP_BONOUS_REWARD : "Signup Bonus Reward",
    SIGNUP_XTRA_CASH_REWARD : "Signup Xtra Cash Reward",
    AFFIL_AMOUNT_AT_DEPOST : "Affiliate Amount In Deposit",
    AFFIL_AMOUNT_WITHDRAWAL_FOR_DEPOST : "Affiliate Amount Withdraw For Deposit",
    WON_CONTEST_FREEGIVEAWAY : "Won free-giveaway In Deposite",
    SERIES_LEADERBOARD_WIN : "Series Leaderboard Reward",
    FRIEND_PAN_VERIFY_XCASH_REWARD: "Friend Pan Verify Xtra Cash Reward",
    FRIEND_BANK_VERIFY_XCASH_REWARD: "Friend Bank Verify Xtra Cash Reward",
    FIRST_DEPOSITE_XCASH_REWARD: "First Deposite Xtra Cash Reward",
    USER_BANK_VERIFY_XCASH_REWARD: "User Bank Verify Xtra Cash Reward",
    REAL_CODE_SIGNUP_XCASH_REWARD: "web11 Code Signup Xtra Cash Reward",
    JOIN_CONTEST_REWARD: "Join Contest Reward In Xtra",
    INSTANT_BANK_VERIFIED: "Instant Bank Verified",
    FRIEND_JOIN_CONTEST_DEPOSIT: "Friend Join Contest Reward In Deposit",
    AFFILIATE_REWARD: "Affiliation Reward",
    AFFILIATE_REWARD_PREDICTION: "Prediction Affiliation Reward",
    AFFILIATE_REWARD_TRADE: "Trade Affiliation Reward"
};

const web11Ludo =  {
    "out_standing" : 'Outstanding',
    "not_played" : "Haven't Played Yet",
    "needs_improvement" : 'Needs Improvement',
    "very_good" : 'Very Good',
};

const kabaddiIntro =  {
    "very_excited" : 'Very Excited',
    "cannot_wait" : "Can't Wait",
    "introduced_earlier" : 'Should Have Introduced Earlier',
    "not_really_buzzed" : 'Not Really Buzzed',
};
const userContest =  {
    "absolutely" : 'Absolutely',
    "could_not_ask_for_more" : "Couldn't Ask For More",
    "difference_would_it_make" : 'What Difference Would It make?',
    "off_form" : 'Off Form',
};
const experienceFootball =  {
    "terrific" : 'Terrific',
    "satisfactory" : "Satisfactory",
    "good" : 'Good',
    "already_played_multiple" : 'Already Played Multiple Matches',
};
const nextGame =  {
    "poker" : 'Poker',
    "rummy" : "Rummy",
    "solitare" : 'Solitaire',
    "fruit_ninja" : 'Fruit Ninja',
    "knife_Hit" : 'Knife Hit',
    "chess" : 'Chess',
};
const mostLike =  {
    "lowest_entry_fee" : 'Lowest Entry Fee',
    "second_innings" : "Second Innings",
    "live_fantasy" : 'Live Fantasy',
    "daily_deals_&_offers" : 'Daily Deals & Offers',
};

const blogTypeList = [
    { value: 'today-prediction', label: 'TODAY MATCH PREDICTION' },
    { value: 'cricket-news', label: 'CRICKET NEWS' },
    { value: 'football-news', label: 'FOOTBALL NEWS' },
    { value: 'fantasy-sports', label: 'FANTASY SPORTS' },
    { value: 'indian-t20', label: 'INDIAN T20' },
    { value: 'general', label: 'GENERAL' },
];

const userWalletType = [
    { value: 'cash_balance', label: 'Deposit Amount' },
    { value: 'bonus_amount', label: 'Bonus Amount' },
    { value: 'winning_balance', label: 'Winning Amount' },
    { value: 'extra_amount', label: 'Xtra Amount' },
    { value: 'affiliate_amount', label: 'Affiliate Amount' },
];

const champTypeList =   {
    "1": "Gautam Gabhir",
    "2": "Taniya Bhatia",
    "3": "Ravindra Pahel",
    "4": "Kuldeep Yadav",
}

const GameID = {
    "pubg": "64746ff3344a094ddf5c04d1" ,
    "free_fire_max": "634a42a89633f3f5b7228455" ,
    "cod": 3 ,
    "clash_royale": 4 ,
    "bgmi": "64746ff3344a094ddf5c04d1"
}

const bgmi={
    "solo": "647470d9344a094ddf5c920a",
    "duo": "6478355ac6920343edb370a6",
    "squad": "647835d5c6920343edb3c788",
}

const free_fire_max = {
    "solo": "634a44c1403dfbbd3ecd147b",
    "duo": "637f528f29add4fac9297a33",
    "squad": "637f542529add4fac9297b8e",
    "tdm": 4,
    "tournament": 5
}

const Map_Length={
    "erangle": "Erangel",
    "shanok": "Sanhok",
    "vikendi": "Vikendi",
    "miramar": "Miramar",
    "bermuda": "Bermuda",
    "purgatory": "Purgatory",
    "30_minutes": "30 Minutes"
}

const Gamerji_Contest_status={
    "1": "UPCOMING",
    "2": "PLAYER DATA SHARED",
    "3": "CREDENTIALS RECEIVED",
    "4": "ONGOING",
    "5": "RESULTS RECEIVED",
    "6": "WINNERS GENERATED",
    "7": "PRIZE DISTRIBUTED",
    "8": "CANCEL BY Partner",
    "9": "CANCEL BY Gamerji",
    "10": "REQUIRED MANUAL CHECK"
}

module.exports = {
    apiBaseUrl,
    distributeUrl,
    updateMatchListCron,
    updateFootballMatchListCron,
    updateKabaddiMatchListCron,
    refreshWinningByMatchCron,
    leaderboardURL,
    cronBaseURL,
    // profitLossManager,
    contestCategory,
    dateTimeFormat,
    majorContestCategories,
    wsApiBaseUrl,
    profitPercent,
    defaultCurrency,
    scheduleType,
    publicTeamImagePath,
    publicPlayerImagePath,
    publicSliderImagePathCloudflare,
    tinyKey,
    maxFileSizeUpload,
    maxFileNameLengthUpload,
    currency,
    adminRoles,
    accessModules,
    defaultAccessModules,
    publicSliderImagePath,
    TransactionTypes,
    TransactionTypesByValues,
    fantasyGullyBaseUrl,
    fantasyPlatformGuid,
    captchaSiteKey,
    admin_mode,
    blogTypeList,

    web11Ludo,
    kabaddiIntro,
    userContest,
    experienceFootball,
    nextGame,
    mostLike,
    champTypeList,
    allCronPythonURL,
    userWalletType,
    GameID,
    bgmi,
    free_fire_max,
    Map_Length,
    Gamerji_Contest_status,
    MultiExchangeValues,
    ENDYSTATUS
};